/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import DeviceRoutes from './device.routes';
import AddDeviceController from './add-device.controller';
import DeviceDirective from './device.directive';
import DeviceTableConfig from './device-table.config';
import DeviceBulkProvisioningController from './bulk-provisioning/bulk-provisioning.controller';
import AssignDeviceController from './assigning/assign-device.controller';

export default angular.module('tektelic.device', [])
    .config(DeviceRoutes)
    .controller('AddDeviceController', AddDeviceController)
    .controller('DeviceBulkProvisioningController', DeviceBulkProvisioningController)
    .controller('AssignDeviceController', AssignDeviceController)
    .directive('tkDevice', DeviceDirective)
    .factory('deviceTableConfig', DeviceTableConfig)
    .name;



// WEBPACK FOOTER //
// ./src/app/device/index.js